import {
  SIGN_IN,
  SIGN_UP,
  USER_ALREADY_EXISTS_CODE,
  USER_DOES_NOT_EXIST_CODE,
} from "constants/magicLink";

const AUTH_REDIRECT_PATHS: Partial<Record<string, string>> = {
  [USER_DOES_NOT_EXIST_CODE]: SIGN_UP,
  [USER_ALREADY_EXISTS_CODE]: SIGN_IN,
};

export const getAuthRedirectUrl = (
  code: string | undefined,
  email: string
): string | null => {
  const path = code ? AUTH_REDIRECT_PATHS[code] : undefined;

  if (!path) return null;

  return `${path}?${new URLSearchParams({ email })}`;
};
